<template>
    <NuxtLayout name="malt-admin-layout">
        <KeepAlive>
            <slot />
        </KeepAlive>
        <Footer />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {Footer} from '#components';
</script>
